import React from 'react';
import BusinessDevelopmentNavBar from '../../../../layouts/business-development/BusinessDevelopmentNavBar';
import BusinessDevelopmentBizDevUsersBody from './BusinessDevelopmentUsersBody';

const BusinessDevelopmentDedicatedCustomers = () => {
    return (
        <div className="s-layout">
            <main className="s-layout__content col-lg-10 p-0">
                <BusinessDevelopmentNavBar currentPage="Bizdev Users" />
                <BusinessDevelopmentBizDevUsersBody />
            </main>
        </div>
    );
};

export default BusinessDevelopmentDedicatedCustomers;